import { inject, Injectable, signal } from '@angular/core';
import { ModularSurveyResponse } from '../interfaces';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ModularSurvey {
  // Service injections
  private _http = inject(HttpClient);
  // private _subdomainService = inject(SubdomainService); // TODO: ASÍ SERÍA PARA EL SSR
  // private _toolsService = inject(ToolsService); // TODO: ASÍ SERÍA PARA EL SSR

  // Signal states
  private _surveyData = signal<ModularSurveyResponse | null>(null);

  // Getters
  public surveyData = this._surveyData.asReadonly();

  // Setters
  setSurveyData(data: ModularSurveyResponse): void {
    this._surveyData.set(data);
  }

  // Local properties
  private _apiUrlBase: string = environment.apiUrlBase;
  // private _token = this._toolsService.tools().token; // TODO: ASÍ SERÍA PARA EL SSR

  // Methods
  setSurveyDataServiceSignal(subdomain: string): void {
    if (this.surveyData()) return;

    this.getSurveyDataResponse(subdomain)
      .subscribe((response: ModularSurveyResponse) => {
        this.setSurveyData(response);
      });
  }

  getSurveyDataResponse(subdomain: string): Observable<ModularSurveyResponse> {
    let urlSubdomain = `${this._apiUrlBase}/api/get-incidents-reporter-survey/${subdomain}`;

    // TODO: DESCOMENTAR ESTO PARA EL SSR SI ES NECESARIO
    //if (this._token) {
    //  urlSubdomain = `${this._apiUrlBase}/api/get-home-app-data/${subdomain}/${this._token}`;
    //}

    // TODO: UNCOMMENT WHEN BACKEND IS READY
    return this._http.get<ModularSurveyResponse>(urlSubdomain).pipe(
      map((response: ModularSurveyResponse) => {
        this.setSurveyData(response);
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
